import _ from "lodash";

// id=1 Cash
// id=2 Cash Balance
// id=3 Credit Balance
export const bundleProduct = (data, products) => (id, selectedId) => {
  const selected_product = Array.from(data);
  if (_.find(data, { id })) {
    const getSelectedProduct = _.partial(
      _.pullAllBy,
      selected_product,
      _,
      "id"
    );

    // Cash(1) remove Credit Balance(3)
    if (id === 1) {
      return getSelectedProduct([{ id: 3 }, { id }]);
    }
    // Cash Balance(2) remove 1, 3, 11
    if (id === 2) {
      return getSelectedProduct([{ id: 1 }, { id: 3 }, { id: 11 }, { id }]);
    }
    return getSelectedProduct([{ id }]);
  } else {
    // Transform data to 1 array.
    const allProduct = _.flatMap(products, (n) => n.items);
    let result;
    if (id === 1) {
      // Cash(1) much have Cash Balance(2)
      result = allProduct.filter((item) => item.id === 2);
    } else if (id === 3) {
      // Credit Balance(3) much have Cash(1), Cash Balance(2)
      result = allProduct.filter((item) => item.id === 1 || item.id === 2);
    } else if (id === 11) {
      // TFEX(11) much have Cash Balance(2)
      result = allProduct.filter((item) => item.id === 2);
    }

    return _.chain(result)
      .map((item) => ({
        id: item.id,
        selected_id: item.selected_id,
      }))
      .concat(selected_product, [{ id: id, selected_id: selectedId }])
      .uniqBy("id")
      .value();
  }
};
